export default __webpack_public_path__ + "static/media/account-circle.99152eb9.svg";